<app-breadcrumb></app-breadcrumb>

<form [formGroup]="formGroup">
  <p-panel header="功能標題">
    <div class="card" #contentElement pBPaaSFocusTrap>
      <div class="grid p-fluid">
        <div class="col-12 md:col-3 lg:col-3">
          <label>文字輸入</label>
          <input type="text" pInputText
            formControlName="input" [id]="parseToId('input')">
        </div>
        <div class="col-12 md:col-3 lg:col-3">
          <label>選擇日期</label>
          <p-calendar [showIcon]="true" appendTo="body"
            formControlName="calendar" dateFormat="yy/mm/dd" dataType="string"
            placeholder="yyyy/mm/dd"
            [showOnFocus]="false"
            [inputId]="parseToId('calendar')">
          </p-calendar>
        </div>
        <div class="col-12 md:col-3 lg:col-3">
          <label>日期區間</label>
          <p-calendar [showIcon]="true" appendTo="body"
            dateFormat="yy/mm/dd" dataType="string"
            selectionMode="range" formControlName="calendarRange"
            [showOnFocus]="false"
            [inputId]="parseToId('calendarRange')">
          </p-calendar>
        </div>
        <div class="col-12 md:col-3 lg:col-3">
          <label>數字輸入</label>
          <p-inputNumber formControlName="inputNumber" [inputId]="parseToId('inputNumber')"></p-inputNumber>
        </div>
      </div>
      <div class="grid p-fluid">
        <div class="col-12 md:col-3 lg:col-3">
          <label class="bpaas-required">下拉選單 (固定選項)</label>
          <p-dropdown *ngIf="langChangeVisible"
            [options]="exampleOptions"
            placeholder="{{ 'option.please-select' | translate }}" [showClear]="true"
            appendTo="body"
            formControlName="dropdown" [inputId]="parseToId('dropdown')"
            [ngClass]="{'ng-dirty': formControlInvalid('dropdown')}">
          </p-dropdown>
          <div *ngIf="formControlInvalid('dropdown')">
            <small class="p-error"
              *ngIf="formControl('dropdown').errors?.['required']">
              {{ 'message.validation.required' | translate }}
            </small>
          </div>
        </div>
        <div class="col-12 md:col-3 lg:col-3">
          <label>自動完成</label>
          <p-autoComplete *ngIf="langChangeVisible"
            [suggestions]="exampleDataSuggestions"
            [forceSelection]="true"
            [minLength]="2" [delay]="300" [showClear]="true"
            [showEmptyMessage]="true" emptyMessage="{{ 'table.no-records-found' | translate }}"
            (completeMethod)="searchExampleDataSuggestions($event)"
            (onClear)="autoCompleteCleared('autoCompleteCode')"
            (onFocus)="autoCompleteFocus($event)"
            (onBlur)="autoCompleteBlur($event)"
            (onKeyUp)="autoCompleteKeyUp($event)"
            (onSelect)="autoCompleteCompleted('autoCompleteCode')"
            dataKey="exampleDataCode"
            appendTo="body"
            formControlName="autoCompleteCode" [inputId]="parseToId('autoCompleteCode')"
            field="{{ 'exampleDataName' | translateFieldName: 'exampleDataName' }}">
            <ng-template let-exampleData pTemplate="item">
              {{ exampleData.exampleDataCode }} {{ exampleData.exampleDataName | translateDataValue: exampleData : 'exampleDataName' }}
            </ng-template>
          </p-autoComplete>
        </div>
        <div class="col-12 md:col-3 lg:col-3">
          <label>動態下拉 (資料少適用)</label>
          <p-dropdown *ngIf="langChangeVisible"
            [options]="dynamicOptions"
            optionLabel="{{ 'label' | translateFieldName: 'label' }}"
            optionValue="value"
            placeholder="{{ 'option.please-select' | translate }}" [showClear]="true"
            appendTo="body"
            formControlName="dynamicDropdown" [inputId]="parseToId('dynamicDropdown')">
          </p-dropdown>
        </div>
        <div class="col-12 md:col-3 lg:col-3">
          <label>自動完成+下拉 (資料少適用)</label>
          <p-autoComplete *ngIf="langChangeVisible"
            [suggestions]="allExampleDataSuggestions"
            [forceSelection]="true"
            [minLength]="2" [delay]="300" [showClear]="true"
            [showEmptyMessage]="true" emptyMessage="{{ 'table.no-records-found' | translate }}"
            (completeMethod)="searchAllExampleDataSuggestions($event)"
            (onClear)="autoCompleteCleared('autoCompleteDropdownCode')"
            (onFocus)="autoCompleteFocus($event)"
            (onBlur)="autoCompleteBlur($event)"
            (onKeyUp)="autoCompleteKeyUp($event)"
            (onSelect)="autoCompleteCompleted('autoCompleteDropdownCode')"
            [dropdown]="true" dropdownMode="blank"
            [completeOnFocus]="false"
            appendTo="body"
            (onFocus)="autoCompleteFocus($event)"
            (onBlur)="autoCompleteBlur($event)"
            (onSelect)="autoCompleteCompleted('autoCompleteDropdownCode')"
            formControlName="autoCompleteDropdownCode" [inputId]="parseToId('autoCompleteDropdownCode')"
            field="{{ 'exampleDataName' | translateFieldName: 'exampleDataName' }}">
            <ng-template let-exampleData pTemplate="item">
              {{ exampleData.exampleDataCode }} {{ exampleData.exampleDataName | translateDataValue: exampleData : 'exampleDataName' }}
            </ng-template>
          </p-autoComplete>
        </div>
      </div>
      <div class="grid p-fluid">
        <div class="col-12 md:col-3 lg:col-3">
          <label>自訂欄位驗證 ( 不能輸入 1 )</label>
          <input type="text" pInputText
            formControlName="custValidation" [id]="parseToId('custValidation')"
            [ngClass]="{'ng-dirty': formControlInvalid('custValidation')}">
          <div *ngIf="formControlInvalid('custValidation')">
            <small class="p-error"
              *ngIf="formControl('custValidation').errors?.['duplicate']">
              {{ 'message.validation.duplicate' | translate }}
            </small>
          </div>
        </div>
      </div>
      <div class="grid p-fluid justify-content-end bpaas-button-row">
        <div class="col-12 md:col-3 lg:col-2">
          <button type="button" pButton label="{{ 'button.upload' | translate }}" (click)="someAction()" [id]="parseToId('btnSomeAction')"></button>
        </div>
      </div>
    </div>
  </p-panel>
</form>
